import { SearchService } from '../services/search.service';

export class SearchModel {

    private _errors: any;
    private _query: string = '';
    private _clients: any[] = [];
    private _bikes: any[] = [];
    private _bills: any[] = [];
    private _services: any[] = [];
    private _loading: boolean;
    private _lastSearch: string;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public searchService: SearchService) {
        this._loading = false;
    };

    //*************************************
    //*************** ACTION **************
    //*************************************

    modelChange() {
        this._loading = true;
        this.searchService.search(this.query, this);
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************


    //*************************************
    //************** METHOD ***************
    //*************************************

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get query(): string {
        return this._query;
    }

    set query(value: string) {
        this._query = value;
    }

    get clients(): any[] {
        return this._clients;
    }

    set clients(value: any[]) {
        this._clients = value;
    }

    get bikes(): any[] {
        return this._bikes;
    }

    set bikes(value: any[]) {
        this._bikes = value;
    }

    get bills(): any[] {
        return this._bills;
    }

    set bills(value: any[]) {
        this._bills = value;
    }

    get services(): any[] {
        return this._services;
    }

    set services(value: any[]) {
        this._services = value;
    }

    set loading(b: boolean) {
        this._loading = b;
    }

    get loading() {
        return this._loading;
    }

    set lastSearch(s: string) {
        this._lastSearch = s;
    }

    get lastSearch() {
        return this._lastSearch;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/search.model.ts